import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

import UpdateProfileBg from '../../../../assets/img/update-profile/update-profile-bg.png'
import UpdateProfileIcon from '../../../../assets/img/update-profile/update-profile.png'
import NewSideBarBG from '../../../../assets/img/sidebar-bgnew.webp'
import GCashRightButton from '../../../../assets/img/gcash/gcash-right.png'

import Avatar from '../../../../components/ui/Avatar/Avatar'
import NotificationCount from '../../../../components/ui/NotificationCount/NotificationCount'
// import LinkButton from '../../../../components/ui/LinkButton/LinkButton'
import TncModalLink from '../../../../components/home/TncModalLink/TncModalLink'
import PrivacyModalLink from '../../../../components/home/PrivacyModalLink/PrivacyModalLink'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

import VerifyEmailCard from '../VerifyEmailCard/VerifyEmailCard'

const profilePageButtonText = css`
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
`

export const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`

export const StyledLink = styled(Link)`
  color: var(--color-fg) !important;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 15px;
  font-size: 12px;
`

export const StyledNormalLink = styled.a`
  color: var(--color-fg) !important;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 15px;
  font-size: 12px;
  cursor: pointer;
`

export const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  min-height: 87px;
  font-size: 0.7rem;
  z-index: 100;

  ${props =>
    props.hasScrolled &&
    css`
  background: url('${NewSideBarBG}'), linear-gradient(var(--color-primary), var(--color-primary));
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 100%;
`}
`

export const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 1.5rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const PageBody = styled.div`
  flex: 1 1 auto;
  padding-bottom: 55px;
`

export const PointsInfo = styled.div`
min-height: 197px;
background-color: var(--color-primary);
background: url('${NewSideBarBG}'), linear-gradient(var(--color-primary), var(--color-primary));
background-position: right top;
background-repeat: no-repeat;
background-size: 100%;

margin-bottom: 20px;
display: flex;
flex-direction: column;
align-items: center;
color: #f6f9ff;
width: 100%;
font-weight: 600;
padding-top: 30px;

${props =>
  props.isAdvanced &&
  css`
    min-height: 250px;
  `}
`

export const ProfileCard = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid #ebebeb;
  border-radius: var(--border-radius-card);
  background: #ffffff;
  color: var(--color-primary);
  padding: 0.75rem 0.875rem;
  margin-bottom: 0.9375rem;
`

export const ProfileDetails = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
`

export const StyledAvatarContainer = styled.div`
  flex: 0 0 auto;
  position: relative;
  width: 3rem;
  height: 3rem;
  margin-right: 20px;
  border-radius: 100%;

  ${props =>
    props.hasBackground &&
    css`
      background-color: var(--color-primary);
      padding: 0.3rem;
    `}
`

export const StyledAvatar = styled(Avatar)`
  width: 100%;
  height: 100%;
  color: #ffffff;
`

export const ProfileBadge = styled.span`
  top: 0;
  right: 0;
  border: 1px solid #ffffff;
  border-radius: 2rem;
  position: absolute;
  background-color: ${props =>
    props.verified ? 'var(--color-primary)' : '#ff4f83'};
  width: 0.875rem;
  height: 0.875rem;
  color: #ffffff;
  font-size: 0.4rem;
  text-align: center;
`

export const ProfileInfo = styled.div`
  width: calc(100% - 3rem - 20px);
`

export const BadgeProfileInfo = styled.div`
  width: 100%;
`

export const NameRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const AdvancedNameRow = styled.div`
  display: inline;
  vertical-align: middle;
  width: 100%;
`

export const ViewProfileLink = styled(Link)`
  font-size: 11px;
  text-decoration: none;
  width: 95px;
  align-items: flex-end;
  text-align: right;
  margin-top: 5px;
`

export const AdvancedViewProfileLink = styled(Link)`
  font-size: 11px;
  text-decoration: none;
  max-width: calc(100% - 95px);
  vertical-align: top;
  margin-top: 5px !important;
  margin-left: 10px;
`

export const UserBadge = styled.div`
  margin-left: 10px;
  height: 48px;
  width: 48px;
  border-radius: 4px;
  /* box-shadow: var(--box-shadow-form); */
  border: 1px solid var(--color-fg-lighter);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 1px;

  img {
    width: 42px;
    height: 42px;
  }
`

export const Name = styled.h3`
  font-size: 1rem;
  color: var(--color-fg);
  font-weight: var(--font-weight-bold);
  padding: 0 !important;
  margin: 0 !important;
  max-width: calc(100% - 95px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AdvancedName = styled(Name)`
  display: inline-block;
  max-width: calc(100% - 95px);
  /* margin-right: 10px; */
`

export const MemberDate = styled.p`
  font-size: 0.75rem;
  color: var(--color-fg-light);
  padding: 0 !important;
  margin: 0;
`

export const RewardsSectionContainer = styled.div`
  margin: 0 1.1875rem;
  height: auto;
  position: relative;
`

export const ProfileNav = styled.ul`
  position: relative;
  list-style: none;
  padding: 0;
  margin: 1.5rem 1.1875rem;
  border-bottom: 1px solid var(--color-fg-lighter);
`

export const NavLink = styled(Link)`
  text-decoration: none;
`

export const NavItem = styled.li`
  color: var(--color-primary);
  cursor: pointer;
  list-style: none;
  padding: 1rem 0;
  border-top: 1px solid var(--color-fg-lighter);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    color: var(--color-primary);
  }
`

export const ItemName = styled.span`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  padding-left: 5px;
  font-size: 0.875rem;
  color: var(--color-primary);

  &:hover {
    color: var(--color-primary-hover);
  }
`

export const StyledNotificationCount = styled(NotificationCount)`
  top: 1rem;
  right: 1.5rem;
`

export const StyledTncModalLink = styled(TncModalLink).attrs({
  zIndex: '10021',
})`
  display: block;
  margin: -20px;
  padding: 20px;
  margin-right: -30px;
  padding-right: 30px;

  &:hover {
    color: unset;
  }
`
export const StyledPrivacyModalLink = styled(PrivacyModalLink).attrs({
  zIndex: '10022',
})`
  display: block;
  margin: -20px;
  padding: 20px;
  margin-right: -30px;
  padding-right: 30px;

  &:hover {
    color: unset;
  }
`

export const PrivacyPolicyLink = styled.a`
  display: block;
  margin: -20px;
  padding: 20px;
  margin-right: -30px;
  padding-right: 30px;
  text-decoration: none;
`

export const StyledVerifyEmailCard = styled(VerifyEmailCard)`
  margin: 0 1.1875rem 0.9375rem 1.1875rem;
  width: calc(100% - 2.375rem) !important;
`

export const PointsDate = styled.div`
  color: #fff;
  font-size: 12px;
  display: block;
  text-align: center;
`

export const MenuContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 1.1875rem;
`

export const MenuItem = styled.div`
  font-size: 12px;
  width: 25%;
`

export const MenuIcon = styled.img`
  width: 48px;
  background-color: #ebeaf9;
  border-radius: 100px;
  padding: 2.5px;
`

export const MenuLabel = styled.div`
  display: block;
  margin-top: 5px;
  padding: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 5.5rem;
  text-align: center;
`

export const MenuSublabel = styled.div`
  font-size: 10px;
  color: #9b9b9b;
`

export const PointsAmount = styled.div`
  font-size: 32px;
`

export const Footer = styled.div`
  text-align: center;
  font-size: 14px;
  padding: 0 2.375rem;
`

export const Store = styled.img`
  width: calc(50% - 8px);
  cursor: pointer;
  height: intrinsic;
`

export const StoreButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`

export const CardListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: var(--border-radius-card);
  margin-bottom: 10px;
  padding: 10px 12px;
  box-shadow: 0 3px 8px 0 rgba(48, 31, 83, 0.07);
`

export const CardTypeImage = styled.img`
  width: 30px;
`
export const CardName = styled.div`
  flex-grow: 1;
  padding-left: 20px;
  text-transform: uppercase;
  font-size: 13.5px;
  font-weight: 600;
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const CardNumber = styled.div`
  flex-grow: 1;
  text-align: right;
  font-size: 13.5px;
  font-weight: 600;
  // padding-right: 30px;
`

export const DeleteButton = styled.button`
  ${profilePageButtonText}
  font-size: 1.2rem;
  background-color: transparent;
  color: var(--color-primary);
  cursor: pointer;
  border: 0;
`

// export const GCashIcon = styled.img`
//   /*height: 1.75rem;
// position: sticky;
// left: 2rem;
// top: 2rem;*/
//   height: 3rem;
//   margin-right: 1rem;
// `

export const GCashListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #007dfe;
  border-radius: var(--border-radius-card);
  margin-bottom: 10px;
  padding: 10px 12px;
  box-shadow: 0 3px 8px 0 rgba(48, 31, 83, 0.07);
  color: white;

  button {
    ${profilePageButtonText}
    color: white;
  }
`

export const GCashButton = styled(ActionButton)`
  ${profilePageButtonText}
  width: 100%;
  background-color: #007dfe;
  border-color: #007dfe;
  margin: 15px 0 0.5rem 0;

  &:hover {
    background-color: #007dfe;
    border-color: #007dfe;
  }
`
// export const GCashStatusMessage = styled.div`
//   ${props => (props.isButton ? 'cursor: pointer;' : '')}
//   width: 100%;
//   box-sizing: border-box;

//   background-color: #ffffff;
//   margin: 25px 0rem 0.5rem 0rem;
//   color: #8a8a8a;
//   border: 1px solid #dddddd;
//   font-size: 0.9rem;
//   padding: 1rem;
//   border-radius: var(--border-radius-button);
//   display: flex;
//   img {
//     position: initial;
//   }
//   .right-button {
//     width: 0.45rem;
//   }
//   span {
//     /*text-align: center;*/
//     flex: 1;
//   }
// `

// export const GCashMessage = styled.div``

// export const GCashHeader = styled.div`
//   font-size: 0.8rem;
//   font-weight: var(--font-weight-bold);
//   display: flex;
//   flex-direction: row;
//   width: 100%;
//   justify-content: space-between;
//   color: #007cff;
// `

export const GCashActionButton = styled.div`
  font-size: 0.6rem;
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  cursor: pointer;
`

export const GCashDescription = styled.div`
  font-size: 0.6rem;
`

export const UpdateProfileButton = styled.button`
  ${profilePageButtonText}
  cursor: pointer;
  width: calc(100% - 1.1875rem * 2);
  box-sizing: border-box;

  background-color: var(--color-primary);
  background-image: url(${UpdateProfileBg});
  background-size: cover;

  margin: 1rem 1.1875rem 25px 1.1875rem;
  color: #8a8a8a;
  font-size: 0.9rem;
  border: none;
  border-radius: var(--border-radius-button);
  display: flex;
  img {
    position: initial;
  }
  .right-button {
    width: 0.45rem;
  }
  span {
    flex: 1;
  }

  padding: 0;
`

// export const GCashContainer = styled.div`
//   margin: 0 1.1rem 1rem 1.1rem;
// `

export const MissingDataHeader = styled.div`
  font-size: 0.8rem;
  font-weight: var(--font-weight-bold);
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  color: var(--color-bg-form);
  margin-bottom: 0.25rem;
`
export const MissingDataBody = styled.div`
  font-size: 0.65rem;
  text-align: left;
  color: var(--color-bg-form);
`
export const MissingDataMessage = styled.div`
  padding: 1rem;
  align-self: center;
`
export const MissingDataIcon = styled.img.attrs({
  src: UpdateProfileIcon,
  alt: 'update profile button',
})`
  height: 4rem;
  margin-top: 0.75rem;
`

export const RightButton = styled.img.attrs({
  src: GCashRightButton,
})`
  ${({ variant }) =>
    variant === 'missing-data' &&
    'filter: grayscale(1) invert(1) contrast(1500%);'}

  width: 0.45rem;
`
